import { ModalService } from "../../modal/modal.service";
import { ORGANIZATION_EXPORT_HANDLERS } from "./organization.export.budget.handler";
import { OrganizationExportModalComponent } from "./organization.export.modal.component";
import { OrganizationExport } from "./organization.export.types";

export class OrganizationExportService {
    /**
     * Opens the organization export modal; on confirm, runs registered handlers and downloads CSV.
     * @returns true when export completed, false when cancelled or nothing selected.
     */
    public static async openAndExport(context: OrganizationExport.Context): Promise<boolean> {
        const selection = await ModalService.byClass(OrganizationExportModalComponent, {
            context,
            title: "Export organization data",
            size: "md",
        });
        if (!selection?.kinds?.length) {
            return false;
        }
        const exportContext = OrganizationExportService.mergeFiscalYearIntoContext(context, selection);
        await OrganizationExportService.runExport(exportContext, selection);
        return true;
    }

    private static mergeFiscalYearIntoContext(
        context: OrganizationExport.Context,
        selection: OrganizationExport.Selection,
    ): OrganizationExport.Context {
        if (!selection.kinds.includes("budget") || selection.fiscalYearId == null) {
            return context;
        }
        return {
            ...context,
            fiscalYearId: selection.fiscalYearId,
            fiscalYear: selection.fiscalYear ?? context.fiscalYear,
        };
    }

    public static async runExport(
        context: OrganizationExport.Context,
        selection: OrganizationExport.Selection,
    ): Promise<void> {
        for (const kind of selection.kinds) {
            const handler = ORGANIZATION_EXPORT_HANDLERS[kind];
            const kindOptions = kind === "budget" ? selection.budget : undefined;
            await handler.run(context, kindOptions);
        }
    }
}
